<div class="grid-container">
    <div class="preview-map-container">
        <app-import-wizard-geospatial-minimap></app-import-wizard-geospatial-minimap>
    </div>
    <div class="features-list-container">
        <div class="filter-container">
            <input
                type="text"
                placeholder="Busque uma ou mais features"
                class="search-input search-input-dimension"
                (input)="search($event)"
            >
        </div>

        <div class="features-list">
            @if(importWizardFiles().length === 0) {
                <app-skeleton variant="horizontal-card" size="sm" *ngFor="let i of [].constructor(4)"></app-skeleton>
            } @else { 
                @for (file of filteredFiles(); track file.id; let i = $index) {
                    <app-geospatial-feature-card 
                    [importWizardFileDetail]="file"
                    [style.animation-delay]="i * 60 + 'ms'"
                    (deletedFile)="handleDeletedImportWizardFile($event)"
                    ></app-geospatial-feature-card>
                }
            }
        </div>
        
    </div>
</div>

<div class="footer-container">
    <span>
        <!-- 7 features restantes -->
    </span>

    <div class="button-container">
        <button class="secondary" (click)="handleCancelClick()"> Descartar Importação </button>
        <button class="primary" (click)="handleValidationClick()"> Validar e Concluir Importação </button>
        <!-- <app-single-select
            id="action"
            [options]="actionsListOptions"
            valueKey="value"
            labelKey="label"
            [hasSearch]="false"
            [initialValue]="actionsListOptions[0]?.value"
            [disabled]="isLoading()"
            [size]="'sm'"
            (selectionChange)="handleActionChange($event)"
        ></app-single-select> -->
    </div>
</div>


<mat-progress-bar
    class="pending-list-progress-bar"
    mode="determinate"
    [value]="loadingProgress()"
    *ngIf="isFinishing()"
></mat-progress-bar>

<app-alert 
    title="Cancelar importação"
    message="Deseja realmente cancelar essa importação? Todo o progresso será perdido."
    confirmText="Confirmar"
    cancelText="Voltar"
    [visible]="isAlertVisible"
    (onConfirmEvent)="handleCancelClickConfirmation()"
    (onCancelEvent)="handleCancelClickCancel()"
></app-alert>